import React from "react";
import { Button } from "../../../../shared/Button/Button";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";
import styles from "../scss/Prescribers.module.scss";
import { useDowngradePrescriber } from "../hooks/useDowngradePrescriber";
import { uiNotification } from "../../../../services/UINotificationService";

const DowngradeEpcsButton = ({ id, setLocalPrescribers }) => {
  const { mutate: downgradePrescriber, isLoading: isDowngrading } =
    useDowngradePrescriber();

  const handleDowngradePrescriber = () => {
    downgradePrescriber(
      { id },
      {
        onSuccess: (response) => {
          const updatedPrescriber = response.data.data.updated_prescriber;

          setLocalPrescribers((prev) =>
            prev.map((prescriber) =>
              prescriber.id === updatedPrescriber.id
                ? updatedPrescriber
                : prescriber,
            ),
          );

          uiNotification.success("Provider downgraded successfully.");
        },
        onError: (error) => {
          uiNotification.error(
            error?.response?.data?.message || "An error occurred.",
          );
        },
      },
    );
  };

  return (
    <Button
      size="small"
      onClick={handleDowngradePrescriber}
      className={styles.upgradeDowngradeButton}
      isDisabled={isDowngrading}
      leftAdornment={
        isDowngrading ? <CircularProgress size="small" color="white" /> : null
      }
    >
      Downgrade to Non-EPCS
    </Button>
  );
};

export default DowngradeEpcsButton;
